interface IconProps {
  className?: string;
}

/**
 * Shopping bag glyph, filled. Inlined instead of the shared sprite
 * (~/components/Icon) because that one renders without a `viewBox` and gets
 * cropped when scaled down via CSS.
 */
const ShoppingBagIcon = ({ className }: IconProps) => (
  <svg viewBox="0 0 20 20" fill="none" aria-hidden className={className}>
    <path
      d="M17.5 16.667C17.5 17.109 17.3243 17.5331 17.0117 17.8457C16.6992 18.1582 16.275 18.334 15.833 18.334H4.16699C3.72504 18.334 3.30083 18.1582 2.98828 17.8457C2.67572 17.5331 2.5 17.109 2.5 16.667V5.75H17.5V16.667ZM13.334 9.25C12.9198 9.25 12.584 9.58579 12.584 10C12.584 10.6851 12.3116 11.3427 11.8271 11.8271C11.3427 12.3115 10.6851 12.583 10 12.583C9.31513 12.5829 8.65819 12.3113 8.17383 11.8271C7.68936 11.3427 7.41699 10.6851 7.41699 10C7.41699 9.58579 7.08121 9.25 6.66699 9.25C6.25278 9.25 5.91699 9.58579 5.91699 10C5.91699 11.083 6.34751 12.1219 7.11328 12.8877C7.87895 13.6532 8.9173 14.0829 10 14.083C11.0829 14.083 12.1219 13.6534 12.8877 12.8877C13.6535 12.1219 14.084 11.083 14.084 10C14.084 9.5859 13.748 9.25018 13.334 9.25ZM16.9375 4.25H3.0625L5 1.66699H15L16.9375 4.25Z"
      fill="currentColor"
    />
  </svg>
);

export default ShoppingBagIcon;
